export default "__VITE_ASSET__DpjM1BtK__"